import React from "react";
import { useTranslation } from "react-i18next";
import { useDashboardThemeConfigs } from "../../../../hooks/useSettings";
import SettingsConfig from "../SettingsConfig";
import BrandingImageField from "./BrandingImageField";

// Order here is the display order in the card.
const BRANDING_KEYS = [
  "dashboard_title",
  "dashboard_logo",
  "dashboard_favicon",
];

const BrandingCard = () => {
  const { t } = useTranslation("whiteLabel");
  const { data: configs = [], isLoading } = useDashboardThemeConfigs();

  const brandingConfigs = BRANDING_KEYS.map((key) =>
    configs.find((c) => c.key === key),
  ).filter(Boolean);

  return (
    <div className="overflow-hidden rounded-lg border border-gray-700 bg-gray-800">
      <div className="p-4">
        <h3 className="text-lg font-medium text-white">
          {t("branding.title")}
        </h3>
        <p className="mt-1 text-sm text-gray-400">
          {t("branding.description")}
        </p>
      </div>
      <div className="border-t border-gray-700 p-4">
        {isLoading ? (
          <div className="space-y-4">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-16 animate-pulse rounded bg-gray-700" />
            ))}
          </div>
        ) : brandingConfigs.length > 0 ? (
          <div className="space-y-4">
            {brandingConfigs.map((config) =>
              config.type === 5 ? (
                <BrandingImageField key={config.id} config={config} />
              ) : (
                <SettingsConfig key={config.id} config={config} />
              ),
            )}
          </div>
        ) : (
          <p className="text-sm text-gray-400">{t("branding.empty")}</p>
        )}
      </div>
    </div>
  );
};

export default BrandingCard;
